import { IconsType } from './types';

export default <T extends IconsType>(collection: T) => collection;
